import { getElement, getElements } from '../../utils/functional';
import { ReactiveState } from '../../utils/reactive-state';
import { DataMap } from './data_map';
import { TargetSet } from './target_set';
export class Context {
  constructor(element, application) {
    this.element = element;
    this.application = application;
    this.state = new ReactiveState({});
    this.targets = new TargetSet(this);
    this.data = new DataMap(this);
  }

  get identifier() {
    return this.element.getAttribute(this.schema.moduleAttribute);
  }

  get schema() {
    return this.application.schema;
  }

  getElement(selector) {
    return getElement(selector, {
      context: this.element
    });
  }

  getElements(selector) {
    return getElements(selector, {
      context: this.element
    });
  }

}